import typeLabel from '@/constants/ActivityTypeLabelsTeacher';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import { Button } from 'antd';
import { usePlausible } from 'next-plausible';
import { useRouter } from 'next/router';
import { useContext } from 'react';

export default function WorksheetButtons({ activity }) {
  const globalContext = useContext(GlobalContext);
  const router = useRouter();
  const plausible = usePlausible();
  function onDownload() {
    plausible('download', {
      props: {
        title: activity.englishName,
        type: activity.type,
        pageUrl: router.asPath,
      },
    });
  }
  return (
    <>
      {activity.data.file &&
      ((globalContext.state.user?.teacher &&
        globalContext.state.isSubscriptionActive) ||
        globalContext.state.user?.student ||
        globalContext.state.user?.admin ||
        activity.free) ? (
        <Button
          type="primary"
          href={activity.data.file}
          target="_blank"
          rel="noreferrer"
          onClick={onDownload}
        >
          <span className="capitalize">
            Download {typeLabel(activity.type)}
          </span>
        </Button>
      ) : null}
      {activity.data.flashCards &&
      ((globalContext.state.user?.teacher &&
        globalContext.state.isSubscriptionActive) ||
        globalContext.state.user?.student ||
        globalContext.state.user?.admin ||
        activity?.free) ? (
        <Button
          type="primary"
          href={activity.data.flashCards}
          target="_blank"
          rel="noreferrer"
          onClick={onDownload}
        >
          Download Flashcards
        </Button>
      ) : null}
    </>
  );
}
